import './App.css';
import IconBusca from "./assets/lipstick.png"
import GlossFrancine from "./assets/gloss_francisca.png"
import GlossMac from "./assets/mac.png"
import GlossMariMaria from "./assets/gloss_marimaria.png"
import GlossNinaSecrets from "./assets/nina_secrets.png"
import GlossOceane from "./assets/oceane.png"
import GlossKiko from "./assets/gloss_kiko.png"
import Gloss from "./components/gloss";
import { useState } from 'react';
import Select from 'react-select';

//componente da nossa tela principal
function App() {

  const [busca, setBusca] = useState("");
  const [ordenacao,setOrdenacao] = useState('padrao')

  const GlossList = [
    {id: 1, imageUrl: GlossFrancine, price:"80",name:"Gloss Francisca"},
    {id: 2, imageUrl: GlossMariMaria, price:"100",name:"Gloss Mari Maria"},
    {id: 3, imageUrl: GlossKiko, price:"70",name:"Gloss Kiko"},
    {id: 4, imageUrl: GlossMac ,price:"120",name:"Gloss Mac"},
    {id: 5, imageUrl: GlossNinaSecrets, price:"99",name:"Gloss Nina Secrets"},
    {id: 6, imageUrl: GlossOceane, price:"150",name:"Gloss Oceane"},
  ]

  const options = [
    {value: 'padrao', label: 'Padrão'},
    {value: 'crescente', label: 'Do menor para o maior'},
    {value: 'decrescente', label: 'Do maior para o menor'},
  ]

  const GlossFilter = GlossList
  .filter((one_gloss) => one_gloss.name.toLocaleLowerCase().includes(busca.toLocaleLowerCase()));

  const listaOrdenada = [...GlossFilter].sort((a,b) => {
    if (ordenacao === 'crescente') {
      return Number(a.price) - Number(b.price);
    }
    if (ordenacao === 'decrescente') {
      return Number(b.price) - Number(a.price);
    }
    return 0;
  })

  const selectedOption = options.find(option => option.value === ordenacao);

  return (
    <div className="App">
      <header className="App-header">
        <p className='title'>
          Loja de Gloss
        </p>
      </header>

      <div className="options-container">

        <div className='search-container'> 
          <img src={IconBusca} className='icon' />
          <input 
          type='text'
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          />
        </div>
        
        <div className="select-container">
          <Select 
          options={options} 
          onChange={(opcao) => setOrdenacao(opcao ? opcao.value:'padrao')}
          value={selectedOption}
          />
        </div>

      </div>

      <div className='content'>

        <div className='card-container'>

          {listaOrdenada.map((gloss) => (
            <Gloss
              key={gloss.id}
              imageUrl={gloss.imageUrl}
              price={gloss.price}
              name={gloss.name}
            />
            ))}

          </div>
      </div>

    </div>
  );
}

export default App;
